import { render, staticRenderFns } from "./ContinuousSubmitCard.vue?vue&type=template&id=17fdc994&scoped=true"
import script from "./ContinuousSubmitCard.vue?vue&type=script&lang=ts"
export * from "./ContinuousSubmitCard.vue?vue&type=script&lang=ts"
import style0 from "./ContinuousSubmitCard.vue?vue&type=style&index=0&id=17fdc994&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fdc994",
  null
  
)

export default component.exports